/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize ContactFloatingButton.
 */

// Redux Actions
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './ContactFloatingButtonView';

export const mapStateToPropsContactFloatingButtonActions = mapStateToProps;
export const mapDispatchToPropsContactFloatingButtonActions =
  mapDispatchToProps;

export default connect(
  mapStateToPropsContactFloatingButtonActions,
  mapDispatchToPropsContactFloatingButtonActions
)(View);
